import { render, staticRenderFns } from "./mktTitle.vue?vue&type=template&id=28b8c14b&"
import script from "./mktTitle.vue?vue&type=script&lang=js&"
export * from "./mktTitle.vue?vue&type=script&lang=js&"
import style0 from "./mktTitle.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports